import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'ntc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  private nomeUsuario: string = null;

  constructor(
    private loginService: LoginService,
    private router: Router
  ) { }

  estaLogado() {
    const estaLogado = this.loginService.estaLogado();

    if ( estaLogado === true ) {
      this.nomeUsuario = this.loginService.getNomeUsuario();
    }

    return estaLogado;
  }

  logoff() {
    notify('Logoff realizado com sucesso!', 'success', 2000);
    this.loginService.logoff();
    this.router.navigate(['/login']);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts